// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useForm } from "react-hook-form";
// import { setProfileData } from "../../Redux/user_information";
// import {
//   config_Api,
//   getProfile,
//   updateImage,
//   updateProfile,
//   orderList,
//   get_countryList,
//   addUser,
//   updateUser,
//   deleteUser,
//   getUser,
// } from "../../Services/Operations/ProductAPI";
// import Footer from "../Components/Footer";
// import Header from "../Components/Header";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import CustomDropdown from "./CustomDropdown";
// import { FaEdit, FaTrash } from "react-icons/fa";

// const SkeletonLoader = ({ type = "profile" }) => {
//   if (type === "profile") {
//     return (
//       <div className="skeleton-container">
//         <div className="skeleton skeleton-circle" />
//         {[...Array(4)].map((_, idx) => (
//           <div key={idx} className="skeleton skeleton-text" />
//         ))}
//       </div>
//     );
//   }

//   if (type === "orders") {
//     return (
//       <div className="skeleton-orders">
//         {[...Array(3)].map((_, idx) => (
//           <div key={idx} className="skeleton-order-card">
//             <div className="skeleton-row"></div>
//             <div className="skeleton-row"></div>
//             <div className="skeleton-row"></div>
//             <div className="skeleton-row"></div>
//           </div>
//         ))}
//       </div>
//     );
//   }

//   if (type === "address") {
//     return (
//       <div className="skeleton-address">
//         <div className="skeleton-header"></div>
//         <div className="skeleton-add-btn"></div>
//         {[...Array(3)].map((_, i) => (
//           <div key={i} className="skeleton-address-card">
//             <div className="skeleton-name"></div>
//             <div className="skeleton-address-line"></div>
//             <div className="skeleton-address-line"></div>
//             <div className="skeleton-phone"></div>
//             <div className="skeleton-actions">
//               <div className="skeleton-icon"></div>
//               <div className="skeleton-icon"></div>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   }
// };

// const Profile = () => {
//   const { tokenDetails } = useSelector((state) => state.user);
//   const token = tokenDetails;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const {
//     register,
//     reset,
//     handleSubmit,
//     setValue,
//     formState: { isSubmitSuccessful, errors },
//   } = useForm();

//   // Profile state
//   const [profile, setProfile] = useState({
//     name: "",
//     email: "",
//     gender: "",
//     dob: "",
//     profileimg: null,
//   });
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [configUrl, setConfigUrl] = useState("");
//   const [profileUpdated, setProfileUpdated] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState("profile");

//   // Address state
//   const [addresses, setAddresses] = useState([]);
//   const [isEditingAddress, setIsEditingAddress] = useState(false);
//   const [currentAddress, setCurrentAddress] = useState(null);
//   const [countries, setCountries] = useState([]);
//   const [isAddressLoading, setIsAddressLoading] = useState(false);

//   // Orders state
//   const [orders, setOrders] = useState([]);
//   const [isOrdersLoading, setIsOrdersLoading] = useState(false);

//   const isMounted = useRef(true);

//   // Fetch initial data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Fetch profile
//         const profileResponse = await getProfile(token);
//         if (profileResponse.success) {
//           const { name, email, gender, dob, profileimg } = profileResponse.data;
//           setProfile({ name, email, gender, dob, profileimg });
//           dispatch(setProfileData(profileResponse.data));
//         }

//         // Fetch config
//         const configResponse = await config_Api();
//         if (configResponse.success) {
//           setConfigUrl(configResponse.data.assetUrl);
//         }

//         // Fetch countries
//         const countriesResponse = await get_countryList();
//         if (countriesResponse.success) {
//           setCountries(countriesResponse.data);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Fetch orders when orders tab is active
//   useEffect(() => {
//     if (activeTab === "orders" && orders.length === 0) {
//       const fetchOrders = async () => {
//         setIsOrdersLoading(true);
//         try {
//           const response = await orderList(token);
//           if (response.success) {
//             setOrders(response.data);
//           }
//         } catch (error) {
//           console.error("Error fetching orders:", error);
//         } finally {
//           setIsOrdersLoading(false);
//         }
//       };
//       fetchOrders();
//     }
//   }, [activeTab]);

//   // Fetch addresses when addresses tab is active
//   useEffect(() => {
//     if (activeTab === "addresses") {
//       const fetchAddresses = async () => {
//         setIsAddressLoading(true);
//         try {
//           const response = await getUser(token);
//           if (response.success) {
//             setAddresses(response.data);
//           }
//         } catch (error) {
//           console.error("Error fetching addresses:", error);
//         } finally {
//           setIsAddressLoading(false);
//         }
//       };
//       fetchAddresses();
//     }
//   }, [activeTab]);

//   const handleFileChange = (e) => {
//     setSelectedFile(e.target.files[0]);
//   };

//   const onSubmitProfile = async (data) => {
//     try {
//       const response = await updateProfile(data, token);
//       if (response.success) {
//         dispatch(setProfileData(response.data));
//         setIsEditing(false);
//         toast.success("Profile updated successfully!");
//       } else {
//         toast.error(response.message);
//       }
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       toast.error("Failed to update profile");
//     }
//   };

//   const handleProfileImgSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedFile) return;

//     const formData = new FormData();
//     formData.append("image", selectedFile);

//     try {
//       const response = await updateImage(formData, token);
//       if (response.success) {
//         setProfile((prev) => ({
//           ...prev,
//           profileimg: response.data.profileimg,
//         }));
//         setProfileUpdated(true);
//         setTimeout(() => setProfileUpdated(false), 500);
//         toast.success("Profile image updated!");
//       } else {
//         toast.error(response.message);
//       }
//     } catch (error) {
//       console.error("Error updating profile image:", error);
//       toast.error("Failed to update profile image");
//     }
//   };

//   const onSubmitAddress = async (data) => {
//     try {
//       let response;
//       if (currentAddress) {
//         // Update existing address
//         const updatedData = { ...currentAddress, ...data };
//         response = await updateUser(updatedData, token);
//       } else {
//         // Add new address
//         response = await addUser(data, token);
//       }

//       if (response.success) {
//         toast.success(
//           `Address ${currentAddress ? "updated" : "added"} successfully!`
//         );
//         setIsEditingAddress(false);
//         setCurrentAddress(null);
//         // Refresh addresses list
//         const addressesResponse = await getUser(token);
//         if (addressesResponse.success) {
//           setAddresses(addressesResponse.data);
//         }
//       } else {
//         toast.error(response.message);
//       }
//     } catch (error) {
//       console.error("Error saving address:", error);
//       toast.error("Failed to save address");
//     }
//   };

//   const handleDeleteAddress = async (id) => {
//     const formData = new FormData();
//     formData.append("addressId", id);

//     try {
//       const result = await deleteUser(formData, token);
//       if (result.success) {
//         toast.success("Address deleted successfully");
//         const addressesResponse = await getUser(token);
//         if (addressesResponse.success) {
//           setAddresses(addressesResponse.data);
//         }
//       }
//     } catch (error) {
//       console.error("Error deleting address:", error);
//       toast.error("Failed to delete address");
//     }
//   };

//   const handleEditAddress = (address) => {
//     setCurrentAddress(address);
//     setIsEditingAddress(true);
//     Object.entries(address).forEach(([key, value]) => {
//       setValue(key, value);
//     });
//   };

//   const handleOrderClick = (id) => {
//     navigate("/order-details", { state: { id } });
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString() + " " + date.toLocaleTimeString();
//   };

//   if (isLoading) {
//     return (
//       <div className="profile-container">
//         <div className="profile-content">
//           <SkeletonLoader type="profile" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="profile-container">
//       <div className="profile-content">
//         {/* Sidebar Navigation */}
//         <div className="profile-sidebar">
//           <div className="profile-user">
//             <div className="profile-picture">
//               {profile.profileimg ? (
//                 <img
//                   src={`${configUrl}/${profile.profileimg}`}
//                   alt="Profile"
//                   className="profile-image"
//                 />
//               ) : (
//                 <div className="profile-image-placeholder">
//                   {profile.name.charAt(0).toUpperCase()}
//                 </div>
//               )}
//             </div>
//             <h3 className="profile-username">{profile.name}</h3>
//             <p className="profile-email">{profile.email}</p>
//           </div>

//           <nav className="profile-nav">
//             <ul>
//               <li>
//                 <button
//                   className={activeTab === "profile" ? "active" : ""}
//                   onClick={() => setActiveTab("profile")}
//                 >
//                   <i className="fas fa-user"></i> Profile
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className={activeTab === "addresses" ? "active" : ""}
//                   onClick={() => setActiveTab("addresses")}
//                 >
//                   <i className="fas fa-map-marker-alt"></i> Addresses
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className={activeTab === "orders" ? "active" : ""}
//                   onClick={() => setActiveTab("orders")}
//                 >
//                   <i className="fas fa-shopping-bag"></i> Orders
//                 </button>
//               </li>
//             </ul>
//           </nav>
//         </div>

//         {/* Main Content */}
//         <div className="profile-main">
//           {/* Profile Tab */}
//           {/* Profile Tab */}
//           {activeTab === "profile" && (
//             <div className="profile-section">
//               <h2 className="section-title">Profile Information</h2>

//               {isEditing ? (
//                 <form
//                   onSubmit={handleSubmit(onSubmitProfile)}
//                   className="profile-form"
//                 >
//                   <div className="form-group">
//                     <label htmlFor="name">Name</label>
//                     <input
//                       type="text"
//                       id="name"
//                       {...register("name", { required: "Name is required" })}
//                       defaultValue={profile.name}
//                     />
//                     {errors.name && (
//                       <span className="error">{errors.name.message}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="email">Email</label>
//                     <input
//                       type="email"
//                       id="email"
//                       {...register("email", { required: "Email is required" })}
//                       defaultValue={profile.email}
//                     />
//                     {errors.email && (
//                       <span className="error">{errors.email.message}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="gender">Gender</label>
//                     <select
//                       id="gender"
//                       {...register("gender", {
//                         required: "Gender is required",
//                       })}
//                       defaultValue={profile.gender}
//                     >
//                       <option value="">Select Gender</option>
//                       <option value="male">Male</option>
//                       <option value="female">Female</option>
//                       <option value="other">Other</option>
//                     </select>
//                     {errors.gender && (
//                       <span className="error">{errors.gender.message}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="dob">Date of Birth</label>
//                     <input
//                       type="date"
//                       id="dob"
//                       {...register("dob", { required: "DOB is required" })}
//                       defaultValue={profile.dob}
//                     />
//                     {errors.dob && (
//                       <span className="error">{errors.dob.message}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label>Profile Picture</label>
//                     <div className="file-upload">
//                       <input
//                         type="file"
//                         onChange={handleFileChange}
//                         id="profile-img"
//                       />
//                       <label htmlFor="profile-img" className="upload-btn">
//                         Choose File
//                       </label>
//                       {selectedFile && <span>{selectedFile.name}</span>}
//                     </div>
//                   </div>

//                   <div className="form-actions">
//                     <button type="submit" className="btn-primary">
//                       Save Changes
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => setIsEditing(false)}
//                       className="btn-secondary"
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               ) : (
//                 <div className="profile-info">
//                   <div className="info-row">
//                     <span className="info-label">Name:</span>
//                     <span className="info-value">{profile.name}</span>
//                   </div>
//                   <div className="info-row">
//                     <span className="info-label">Email:</span>
//                     <span className="info-value">{profile.email}</span>
//                   </div>
//                   <div className="info-row">
//                     <span className="info-label">Gender:</span>
//                     <span className="info-value">
//                       {profile.gender || "Not specified"}
//                     </span>
//                   </div>
//                   <div className="info-row">
//                     <span className="info-label">Date of Birth:</span>
//                     <span className="info-value">
//                       {profile.dob || "Not specified"}
//                     </span>
//                   </div>

//                   <button
//                     onClick={() => setIsEditing(true)}
//                     className="btn-primary edit-btn"
//                   >
//                     Edit Profile
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Addresses Tab */}
//           {activeTab === "addresses" && (
//             <div className="profile-section">
//               <h2 className="section-title">SELECT DELIVERY ADDRESS</h2>

//               {isEditingAddress ? (
//                 <form
//                   onSubmit={handleSubmit(onSubmitAddress)}
//                   className="address-form"
//                 >
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       id="name"
//                       className="form-input"
//                       placeholder="Full name"
//                       {...register("name", {
//                         required: "Full name is required",
//                       })}
//                     />
//                     {errors.name && (
//                       <p className="error-message">{errors.name.message}</p>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <input
//                       type="text"
//                       id="mobile_no"
//                       className="form-input"
//                       placeholder="Phone Number"
//                       {...register("mobile_no", {
//                         required: "Phone number is required",
//                       })}
//                     />
//                     {errors.mobile_no && (
//                       <p className="error-message">
//                         {errors.mobile_no.message}
//                       </p>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <input
//                       type="text"
//                       id="address"
//                       className="form-input"
//                       placeholder="Address"
//                       {...register("address", {
//                         required: "Address is required",
//                       })}
//                     />
//                     {errors.address && (
//                       <p className="error-message">{errors.address.message}</p>
//                     )}
//                   </div>

//                   <div className="form-row">
//                     <div className="form-group">
//                       <input
//                         type="text"
//                         id="city"
//                         className="form-input"
//                         placeholder="City"
//                         {...register("city", { required: "City is required" })}
//                       />
//                       {errors.city && (
//                         <p className="error-message">{errors.city.message}</p>
//                       )}
//                     </div>

//                     <div className="form-group">
//                       <input
//                         type="text"
//                         id="state"
//                         className="form-input"
//                         placeholder="State"
//                         {...register("state", {
//                           required: "State is required",
//                         })}
//                       />
//                       {errors.state && (
//                         <p className="error-message">{errors.state.message}</p>
//                       )}
//                     </div>
//                   </div>

//                   <div className="form-row">
//                     <div className="form-group">
//                       <CustomDropdown
//                         options={countries}
//                         onSelect={(value) => setValue("country", value)}
//                         register={register}
//                         name="country"
//                         errors={errors}
//                         placeholder="Country"
//                         className="form-input"
//                       />
//                       {errors.country && (
//                         <p className="error-message">
//                           {errors.country.message}
//                         </p>
//                       )}
//                     </div>

//                     <div className="form-group">
//                       <input
//                         type="text"
//                         id="pincode"
//                         className="form-input"
//                         placeholder="Zip Code (Postal Code)"
//                         {...register("pincode", {
//                           required: "Zip code is required",
//                         })}
//                       />
//                       {errors.pincode && (
//                         <p className="error-message">
//                           {errors.pincode.message}
//                         </p>
//                       )}
//                     </div>
//                   </div>

//                   <div className="form-actions">
//                     <button type="submit" className="save-button">
//                       SAVE ADDRESS
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setIsEditingAddress(false);
//                         setCurrentAddress(null);
//                       }}
//                       className="cancel-button"
//                     >
//                       CANCEL
//                     </button>
//                   </div>
//                 </form>
//               ) : (
//                 <>
//                   {isAddressLoading ? (
//                     <SkeletonLoader type="address" />
//                   ) : (
//                     <div className="addresses-container">
//                       <button
//                         onClick={() => setIsEditingAddress(true)}
//                         className="add-address-button"
//                       >
//                         + Add New Address
//                       </button>

//                       {addresses.length > 0 ? (
//                         <div className="address-list">
//                           {addresses.map((address) => (
//                             <div key={address.id} className="address-card">
//                               <div className="address-details">
//                                 <h4 className="address-name">{address.name}</h4>
//                                 <p className="address-info">
//                                   {address.address}
//                                 </p>
//                                 <p className="address-info">
//                                   {address.city}, {address.state},{" "}
//                                   {address.country}
//                                 </p>
//                                 <p className="address-info">
//                                   Zip: {address.pincode}
//                                 </p>
//                                 <p className="address-info">
//                                   Phone: {address.mobile_no}
//                                 </p>
//                               </div>
//                               <div className="address-actions">
//                                 <button
//                                   onClick={() => handleEditAddress(address)}
//                                   className="edit-button"
//                                 >
//                                   Edit
//                                 </button>
//                                 <button
//                                   className="delete-button"
//                                   onClick={() =>
//                                     handleDeleteAddress(address.id)
//                                   }
//                                 >
//                                   Delete
//                                 </button>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <div className="empty-state">
//                           <i className="fas fa-map-marker-alt"></i>
//                           <p>You haven't saved any addresses yet</p>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           )}

//           {/* Orders Tab */}
//           {activeTab === "orders" && (
//             <div className="profile-section">
//               <h2 className="section-title">My Orders</h2>

//               {isOrdersLoading ? (
//                 <SkeletonLoader type="orders" />
//               ) : (
//                 <div className="orders-container">
//                   {orders.length > 0 ? (
//                     <div className="order-list">
//                       {orders.map((order) => (
//                         <div
//                           key={order.id}
//                           className="order-card"
//                           onClick={() => handleOrderClick(order.id)}
//                         >
//                           <div className="order-header">
//                             <span className="order-id">Order #{order.id}</span>
//                             <span className="order-date">
//                               {formatDate(order.created_at)}
//                             </span>
//                           </div>
//                           <div className="order-details">
//                             <div className="order-status">
//                               <span>Status:</span>
//                               <span
//                                 className={`status-${order.order_status.toLowerCase()}`}
//                               >
//                                 {order.order_status}
//                               </span>
//                             </div>
//                             <div className="order-total">
//                               <span>Total:</span>
//                               <span>${order.total_amount}</span>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div className="empty-state">
//                       <i className="fas fa-shopping-bag"></i>
//                       <p>You haven't placed any orders yet</p>
//                       <button
//                         className="btn-primary"
//                         onClick={() => navigate("/")}
//                       >
//                         Start Shopping
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       <Footer />

//       <style jsx>{`
//         /* Profile container styles */
//         .profile-container {
//           min-height: 100vh;
//           display: flex;
//           flex-direction: column;
//         }

//         .profile-content {
//           display: flex;
//           flex: 1;
//           background-color: #f8f9fa;
//         }

//         /* Sidebar styles */
//         .profile-sidebar {
//           width: 280px;
//           background: white;
//           padding: 30px 20px;
//           box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
//         }

//         .profile-user {
//           text-align: center;
//           margin-bottom: 30px;
//         }

//         .profile-picture {
//           margin: 0 auto 15px;
//         }

//         .profile-image {
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           object-fit: cover;
//           border: 4px solid #f1f1f1;
//         }

//         .profile-image-placeholder {
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           background: #e9ecef;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto;
//           font-size: 36px;
//           color: #495057;
//           border: 4px solid #f1f1f1;
//         }

//         .profile-username {
//           font-size: 18px;
//           margin-bottom: 5px;
//           color: #333;
//         }

//         .profile-email {
//           font-size: 14px;
//           color: #6c757d;
//         }

//         .profile-nav ul {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }

//         .profile-nav li button {
//           display: flex;
//           align-items: center;
//           width: 100%;
//           padding: 12px 15px;
//           background: none;
//           border: none;
//           text-align: left;
//           color: #495057;
//           text-decoration: none;
//           border-radius: 5px;
//           margin-bottom: 5px;
//           transition: all 0.3s;
//           cursor: pointer;
//         }

//         .profile-nav li button i {
//           margin-right: 10px;
//           width: 20px;
//           text-align: center;
//         }

//         .profile-nav li button:hover {
//           background: #f1f1f1;
//           color: #000;
//         }

//         .profile-nav li button.active {
//           background: #f1f1f1;
//           color: #000;
//           font-weight: 500;
//         }

//         /* Main content styles */
//         .profile-main {
//           flex: 1;
//           padding: 30px;
//           background: white;
//           margin: 20px;
//           border-radius: 10px;
//           box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
//         }

//         .section-title {
//           font-size: 24px;
//           margin-bottom: 25px;
//           color: #333;
//           padding-bottom: 10px;
//           border-bottom: 1px solid #eee;
//         }

//         /* Address section specific styles */
//         .addresses-container {
//           margin-top: 20px;
//         }

//         .add-address-button {
//           background-color: #000;
//           color: white;
//           border: none;
//           border-radius: 30px;
//           padding: 12px 30px;
//           font-size: 16px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: background-color 0.3s;
//           margin-bottom: 30px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//         }

//         .add-address-button:hover {
//           background-color: #333;
//         }

//         .address-list {
//           display: grid;
//           gap: 20px;
//         }

//         .address-card {
//           padding: 20px;
//           border: 1px solid #eee;
//           border-radius: 12px;
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           transition: all 0.3s;
//         }

//         .address-card:hover {
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//         }

//         .address-details {
//           flex: 1;
//         }

//         .address-name {
//           font-size: 18px;
//           font-weight: 600;
//           margin-bottom: 10px;
//           color: #333;
//         }

//         .address-info {
//           font-size: 14px;
//           color: #555;
//           margin-bottom: 5px;
//         }

//         .address-actions {
//           display: flex;
//           gap: 10px;
//         }

//         .edit-button,
//         .delete-button {
//           padding: 8px 15px;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-size: 14px;
//           transition: background-color 0.3s;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .edit-button {
//           background-color: #007bff;
//         }

//         .edit-button:hover {
//           background-color: #0069d9;
//         }

//         .delete-button {
//           background-color: #dc3545;
//         }

//         .delete-button:hover {
//           background-color: #c82333;
//         }

//         /* Empty state styles */
//         .empty-state {
//           text-align: center;
//           padding: 40px 20px;
//           background: #f8f9fa;
//           border-radius: 10px;
//         }

//         .empty-state i {
//           font-size: 50px;
//           color: #6c757d;
//           margin-bottom: 20px;
//         }

//         .empty-state p {
//           font-size: 18px;
//           color: #6c757d;
//           margin-bottom: 20px;
//         }

//         /* Skeleton loader styles */
//         .skeleton-container {
//           padding: 40px;
//           max-width: 600px;
//           margin: 0 auto;
//         }

//         .skeleton {
//           background-color: #e2e2e2;
//           border-radius: 4px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         .skeleton-circle {
//           width: 140px;
//           height: 140px;
//           margin: 0 auto 25px;
//           border-radius: 50%;
//         }

//         .skeleton-text {
//           height: 20px;
//           margin-bottom: 20px;
//           width: 100%;
//         }

//         .skeleton-address {
//           width: 90%;
//           margin: 20px auto;
//           padding: 20px;
//         }

//         .skeleton-header {
//           height: 40px;
//           width: 200px;
//           background: #e0e0e0;
//           margin: 0 auto 20px;
//           border-radius: 4px;
//           animation: pulse 1.5s ease-in-out infinite;
//         }

//         .skeleton-add-btn {
//           height: 40px;
//           width: 180px;
//           background: #f0f0f0;
//           margin-bottom: 20px;
//           border-radius: 33px;
//           animation: pulse 1.5s ease-in-out infinite;
//         }

//         .skeleton-address-card {
//           background: #fff;
//           border-radius: 8px;
//           padding: 20px;
//           margin-bottom: 20px;
//           box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//         }

//         .skeleton-name {
//           height: 24px;
//           width: 150px;
//           background: #f0f0f0;
//           margin-bottom: 15px;
//           border-radius: 4px;
//           animation: pulse 1.5s ease-in-out infinite;
//         }

//         .skeleton-address-line {
//           height: 16px;
//           background: #f0f0f0;
//           margin-bottom: 8px;
//           border-radius: 4px;
//           animation: pulse 1.5s ease-in-out infinite;
//         }

//         .skeleton-phone {
//           height: 16px;
//           width: 120px;
//           background: #f0f0f0;
//           margin-bottom: 15px;
//           border-radius: 4px;
//           animation: pulse 1.5s ease-in-out infinite;
//         }

//         .skeleton-actions {
//           display: flex;
//           gap: 15px;
//         }

//         .skeleton-icon {
//           height: 20px;
//           width: 20px;
//           background: #f0f0f0;
//           border-radius: 50%;
//           animation: pulse 1.5s ease-in-out infinite;
//         }

//         @keyframes pulse {
//           0%,
//           100% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0.5;
//           }
//         }

//         /* Responsive styles */
//         @media (max-width: 768px) {
//           .profile-content {
//             flex-direction: column;
//           }

//           .profile-sidebar {
//             width: 100%;
//             padding: 20px;
//           }

//           .profile-nav ul {
//             display: flex;
//             overflow-x: auto;
//             padding-bottom: 10px;
//           }

//           .profile-nav li {
//             flex: 0 0 auto;
//           }

//           .profile-nav li button {
//             margin-bottom: 0;
//             margin-right: 10px;
//           }

//           .profile-main {
//             margin: 0;
//             border-radius: 0;
//             padding: 20px;
//           }

//           .address-card {
//             flex-direction: column;
//             gap: 15px;
//           }

//           .address-actions {
//             justify-content: flex-end;
//             width: 100%;
//           }
//         }
//       `}</style>
//       <style jsx>{`
//         .profile-container {
//           min-height: 100vh;
//           display: flex;
//           flex-direction: column;
//         }

//         .profile-content {
//           display: flex;
//           flex: 1;
//           background-color: #f8f9fa;
//         }

//         .profile-sidebar {
//           width: 280px;
//           background: white;
//           padding: 30px 20px;
//           box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
//         }

//         .profile-user {
//           text-align: center;
//           margin-bottom: 30px;
//         }

//         .profile-picture {
//           margin: 0 auto 15px;
//         }

//         .profile-image {
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           object-fit: cover;
//           border: 4px solid #f1f1f1;
//         }

//         .profile-image-placeholder {
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           background: #e9ecef;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto;
//           font-size: 36px;
//           color: #495057;
//           border: 4px solid #f1f1f1;
//         }

//         .profile-username {
//           font-size: 18px;
//           margin-bottom: 5px;
//           color: #333;
//         }

//         .profile-email {
//           font-size: 14px;
//           color: #6c757d;
//         }

//         .profile-nav ul {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }

//         .profile-nav li button {
//           display: flex;
//           align-items: center;
//           width: 100%;
//           padding: 12px 15px;
//           background: none;
//           border: none;
//           text-align: left;
//           color: #495057;
//           text-decoration: none;
//           border-radius: 5px;
//           margin-bottom: 5px;
//           transition: all 0.3s;
//           cursor: pointer;
//         }

//         .profile-nav li button i {
//           margin-right: 10px;
//           width: 20px;
//           text-align: center;
//         }

//         .profile-nav li button:hover {
//           background: #f1f1f1;
//           color: #000;
//         }

//         .profile-nav li button.active {
//           background: #f1f1f1;
//           color: #000;
//           font-weight: 500;
//         }

//         .profile-main {
//           flex: 1;
//           padding: 30px;
//           background: white;
//           margin: 20px;
//           border-radius: 10px;
//           box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
//         }

//         .section-title {
//           font-size: 24px;
//           margin-bottom: 25px;
//           color: #333;
//           padding-bottom: 10px;
//           border-bottom: 1px solid #eee;
//         }

//         .profile-form,
//         .address-form {
//           max-width: 600px;
//         }

//         .form-group {
//           margin-bottom: 20px;
//         }

//         .form-group label {
//           display: block;
//           margin-bottom: 8px;
//           font-weight: 500;
//           color: #555;
//         }

//         .form-group input,
//         .form-group select {
//           width: 100%;
//           padding: 10px 15px;
//           border: 1px solid #ddd;
//           border-radius: 5px;
//           font-size: 16px;
//           transition: border 0.3s;
//         }

//         .form-group input:focus,
//         .form-group select:focus {
//           border-color: #007bff;
//           outline: none;
//         }

//         .error {
//           color: #dc3545;
//           font-size: 14px;
//           margin-top: 5px;
//           display: block;
//         }

//         .file-upload {
//           display: flex;
//           align-items: center;
//         }

//         .file-upload input[type="file"] {
//           display: none;
//         }

//         .upload-btn {
//           padding: 10px 15px;
//           background: #f8f9fa;
//           border: 1px solid #ddd;
//           border-radius: 5px;
//           cursor: pointer;
//           margin-right: 10px;
//           transition: all 0.3s;
//         }

//         .upload-btn:hover {
//           background: #e9ecef;
//         }

//         .form-actions {
//           display: flex;
//           gap: 15px;
//           margin-top: 25px;
//         }

//         .btn-primary {
//           padding: 10px 20px;
//           background: #000;
//           color: white;
//           border: none;
//           border-radius: 5px;
//           cursor: pointer;
//           font-size: 16px;
//           transition: background 0.3s;
//         }

//         .btn-primary:hover {
//           background: #333;
//         }

//         .btn-secondary {
//           padding: 10px 20px;
//           background: #6c757d;
//           color: white;
//           border: none;
//           border-radius: 5px;
//           cursor: pointer;
//           font-size: 16px;
//           transition: background 0.3s;
//         }

//         .btn-secondary:hover {
//           background: #5a6268;
//         }

//         .profile-info {
//           max-width: 600px;
//         }

//         .info-row {
//           display: flex;
//           margin-bottom: 15px;
//           padding-bottom: 15px;
//           border-bottom: 1px solid #f1f1f1;
//         }

//         .info-label {
//           font-weight: 500;
//           color: #555;
//           width: 150px;
//         }

//         .info-value {
//           flex: 1;
//           color: #333;
//         }

//         .edit-btn {
//           margin-top: 20px;
//         }

//         .addresses-container,
//         .orders-container {
//           margin-top: 20px;
//         }

//         .address-list {
//           display: grid;
//           gap: 20px;
//         }

//         .address-card {
//           padding: 20px;
//           border: 1px solid #eee;
//           border-radius: 8px;
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//         }

//         .address-details {
//           flex: 1;
//         }

//         .address-actions {
//           display: flex;
//           gap: 10px;
//         }

//         .btn-edit {
//           padding: 5px 10px;
//           background: #007bff;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .btn-delete {
//           padding: 5px 10px;
//           background: #dc3545;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .add-address-btn {
//           margin-top: 20px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .order-list {
//           display: grid;
//           gap: 15px;
//         }

//         .order-card {
//           padding: 15px;
//           border: 1px solid #eee;
//           border-radius: 8px;
//           cursor: pointer;
//           transition: all 0.3s;
//         }

//         .order-card:hover {
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//         }

//         .order-header {
//           display: flex;
//           justify-content: space-between;
//           margin-bottom: 10px;
//         }

//         .order-id {
//           font-weight: bold;
//         }

//         .order-date {
//           color: #6c757d;
//         }

//         .order-details {
//           display: flex;
//           justify-content: space-between;
//         }

//         .order-status {
//           display: flex;
//           gap: 5px;
//         }

//         .status-pending {
//           color: #ffc107;
//         }

//         .status-completed {
//           color: #28a745;
//         }

//         .status-cancelled {
//           color: #dc3545;
//         }

//         .order-total {
//           display: flex;
//           gap: 5px;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 40px 20px;
//           background: #f8f9fa;
//           border-radius: 10px;
//         }

//         .empty-state i {
//           font-size: 50px;
//           color: #6c757d;
//           margin-bottom: 20px;
//         }

//         .empty-state p {
//           font-size: 18px;
//           color: #6c757d;
//           margin-bottom: 20px;
//         }

//         /* Skeleton styles */
//         .skeleton-container {
//           padding: 40px;
//           max-width: 600px;
//           margin: 0 auto;
//         }

//         .skeleton {
//           background-color: #e2e2e2;
//           border-radius: 4px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         .skeleton-circle {
//           width: 140px;
//           height: 140px;
//           margin: 0 auto 25px;
//           border-radius: 50%;
//         }

//         .skeleton-text {
//           height: 20px;
//           margin-bottom: 20px;
//           width: 100%;
//         }

//         .skeleton-orders {
//           display: grid;
//           gap: 15px;
//         }

//         .skeleton-order-card {
//           padding: 15px;
//           border: 1px solid #eee;
//           border-radius: 8px;
//         }

//         .skeleton-row {
//           height: 16px;
//           background-color: #e2e2e2;
//           border-radius: 4px;
//           margin-bottom: 10px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         .skeleton-address {
//           max-width: 600px;
//         }

//         .skeleton-form {
//           display: grid;
//           gap: 20px;
//         }

//         .skeleton-input {
//           height: 40px;
//           background-color: #e2e2e2;
//           border-radius: 4px;
//           animation: pulse 1.5s infinite ease-in-out;
//         }

//         @keyframes pulse {
//           0% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0.5;
//           }
//           100% {
//             opacity: 1;
//           }
//         }

//         @media (max-width: 768px) {
//           .profile-content {
//             flex-direction: column;
//             width: 100%;
//           }

//           .profile-sidebar {
//             width: 100%;
//             padding: 20px;
//           }

//           .profile-nav ul {
//             display: flex;
//             overflow-x: auto;
//             padding-bottom: 10px;
//           }

//           .profile-nav li {
//             flex: 0 0 auto;
//           }

//           .profile-nav li a {
//             margin-bottom: 0;
//             margin-right: 10px;
//           }

//           .profile-main {
//             margin: 0;
//             border-radius: 0;
//             padding: 20px;
//           }

//           .info-row {
//             flex-direction: column;
//           }

//           .info-label {
//             width: 100%;
//             margin-bottom: 5px;
//           }

//           .address-card {
//             flex-direction: column;
//             gap: 15px;
//           }

//           .address-actions {
//             justify-content: flex-end;
//           }
//         }
//         @media (max-width: 568px) {
//           .profile-nav li button {
//             padding: 8px 4px;

//             text-align: center;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { setProfileData } from "../../Redux/user_information";
import {
  config_Api,
  getProfile,
  updateImage,
  updateProfile,
  orderList,
  get_countryList,
  addUser,
  updateUser,
  deleteUser,
  getUser,
  getsaveDesign,
} from "../../Services/Operations/ProductAPI";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomDropdown from "./CustomDropdown";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  FaPen,
  FaShareAlt,
  FaCopy,
  FaTrashAlt,
  FaEye,
  FaCartPlus,
  FaInfoCircle,
  FaTh,
} from "react-icons/fa";
import { FaRuler, FaTag } from "react-icons/fa6";
import { BsThreeDots } from "react-icons/bs";

const SkeletonLoader = ({ type = "profile" }) => {
  if (type === "profile") {
    return (
      <div className="skeleton-container">
        <div className="skeleton skeleton-circle" />
        {[...Array(4)].map((_, idx) => (
          <div key={idx} className="skeleton skeleton-text" />
        ))}
      </div>
    );
  }

  if (type === "orders") {
    return (
      <div className="skeleton-orders">
        {[...Array(3)].map((_, idx) => (
          <div key={idx} className="skeleton-order-card">
            <div className="skeleton-row"></div>
            <div className="skeleton-row"></div>
            <div className="skeleton-row"></div>
            <div className="skeleton-row"></div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "address") {
    return (
      <div className="skeleton-address">
        <div className="skeleton-header"></div>
        <div className="skeleton-add-btn"></div>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="skeleton-address-card">
            <div className="skeleton-name"></div>
            <div className="skeleton-address-line"></div>
            <div className="skeleton-address-line"></div>
            <div className="skeleton-phone"></div>
            <div className="skeleton-actions">
              <div className="skeleton-icon"></div>
              <div className="skeleton-icon"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }
};

const Profile = () => {
  const { tokenDetails } = useSelector((state) => state.user);
  const token = tokenDetails;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { isSubmitSuccessful, errors },
  } = useForm();

  // Profile state
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    gender: "",
    dob: "",
    profileimg: null,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [configUrl, setConfigUrl] = useState("");
  const [profileUpdated, setProfileUpdated] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("profile");

  // Draft state
  const [drafts, setDrafts] = useState([]);
  const [isDraftsLoading, setIsDraftsLoading] = useState(false);

  // Address state
  const [addresses, setAddresses] = useState([]);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [currentAddress, setCurrentAddress] = useState(null);
  const [countries, setCountries] = useState([]);
  const [isAddressLoading, setIsAddressLoading] = useState(false);

  // Orders state
  const [orders, setOrders] = useState([]);
  const [isOrdersLoading, setIsOrdersLoading] = useState(false);

  const isMounted = useRef(true);

  useEffect(() => {
    if (activeTab === "drafts") {
      fetchDrafts();
    }
  }, [activeTab]);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch profile
        const profileResponse = await getProfile(token);
        if (profileResponse.success) {
          const { name, email, gender, dob, profileimg } = profileResponse.data;
          setProfile({ name, email, gender, dob, profileimg });
          dispatch(setProfileData(profileResponse.data));
        }

        // Fetch config
        const configResponse = await config_Api();
        if (configResponse.success) {
          setConfigUrl(configResponse.data.assetUrl);
        }

        // Fetch countries
        const countriesResponse = await get_countryList();
        if (countriesResponse.success) {
          setCountries(countriesResponse.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const fetchDrafts = async () => {
    setIsDraftsLoading(true);
    try {
      const formData = new FormData();
      const response = await getsaveDesign(formData, token);
      console.log("Full API Response:", response);

      if (response.data && response.data.success) {
        // Access the drafts from response.data.data.glb
        const draftsData = response.data.data.glb || [];
        console.log("Raw drafts data:", draftsData);

        const formattedDrafts = draftsData.map((draftItem, index) => {
          console.log("Processing draft item:", draftItem);

          // Extract the first item from data array
          const draft =
            draftItem.data && draftItem.data.length > 0
              ? draftItem.data[0]
              : {};
          console.log("Extracted draft data:", draft);

          // Parse settings if it's a string
          let settings = {};
          try {
            if (draft.settings) {
              settings =
                typeof draft.settings === "string"
                  ? JSON.parse(draft.settings)
                  : draft.settings;
            }
          } catch (error) {
            console.error("Error parsing settings:", error);
          }

          // Get the image URL - check for glb_image first, then fallback to item image
          let productImage = "../glbImage.png";
          if (draft.glb_image) {
            productImage = `${configUrl}/${draft.glb_image}`;
          } else if (draftItem.image) {
            productImage = `${configUrl}/${draftItem.image}`;
          }

          // Format the draft object
          const formattedDraft = {
            id: draft.id || draft.cart_id || `draft-${index}`,
            cartId: draft.cart_id || draftItem.cart_id,
            glbId: draftItem.glb_id || draft.glb_id,
            title: draftItem.name || "Custom Design Jersey",
            date: draft.created_at || new Date().toISOString().split("T")[0],
            items: draft.qty || 1,
            total: draft.total_amount ? `$${draft.total_amount}` : "$0.00",
            status: "draft",
            productImage: productImage,
            productTitle: draftItem.name || "Custom Design Jersey",
            userName: profile.name,
            productPrice: draft.product_price,
            size: draft.size ? draft.size.name : "N/A",
            settings: settings,
            // Raw data for editing
            rawData: draft,
            // Include the full draftItem for debugging
            fullItem: draftItem,
          };

          console.log("Formatted draft:", formattedDraft);
          return formattedDraft;
        });

        setDrafts(formattedDrafts);
        console.log("All formatted drafts:", formattedDrafts);
      } else {
        console.error("API returned unsuccessful:", response.data);
      }
    } catch (error) {
      console.error("Error fetching drafts:", error);
      toast.error("Failed to load drafts");
    } finally {
      setIsDraftsLoading(false);
    }
  };

  // Also, let's add a refresh button and improve the empty state
  const handleRefreshDrafts = () => {
    if (activeTab === "drafts") {
      fetchDrafts();
    }
  };

  const handleDraftClick = (draft) => {
    console.log("draft : ", draft);
    navigate("/3d-product", {
      state: {
        draftId: draft.id,
        cartId: draft.cartId,
        glbId: draft.glbId,
        draftData: draft,
        settings: draft.settings,
        restoreData: draft.rawData,
        // menuSlug: "men",
        // subcategorySlug: "men-jersey",
        menuSlug: "women",
        subcategorySlug: "women-badminton-jersey",
      },
    });
    toast.info("Continue editing your draft");
  };

  const handleDeleteDraft = async (draftId, cartId) => {
    try {
      // Implement delete draft API call here
      // You'll need to pass cart_id to delete the specific draft
      // const response = await deleteDraft(cartId, token);
      // if (response.success) {
      setDrafts(drafts.filter((draft) => draft.id !== draftId));
      toast.success("Draft deleted successfully");
      // }
    } catch (error) {
      console.error("Error deleting draft:", error);
      toast.error("Failed to delete draft");
    }
  };

  // Fetch orders when orders tab is active
  useEffect(() => {
    if (activeTab === "orders" && orders.length === 0) {
      const fetchOrders = async () => {
        setIsOrdersLoading(true);
        try {
          const response = await orderList(token);
          if (response.success) {
            setOrders(response.data);
          }
        } catch (error) {
          console.error("Error fetching orders:", error);
        } finally {
          setIsOrdersLoading(false);
        }
      };
      fetchOrders();
    }
  }, [activeTab]);

  // Fetch addresses when addresses tab is active
  useEffect(() => {
    if (activeTab === "addresses") {
      const fetchAddresses = async () => {
        setIsAddressLoading(true);
        try {
          const response = await getUser(token);
          if (response.success) {
            setAddresses(response.data);
          }
        } catch (error) {
          console.error("Error fetching addresses:", error);
        } finally {
          setIsAddressLoading(false);
        }
      };
      fetchAddresses();
    }
  }, [activeTab]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onSubmitProfile = async (data) => {
    try {
      const response = await updateProfile(data, token);
      if (response.success) {
        dispatch(setProfileData(response.data));
        setIsEditing(false);
        toast.success("Profile updated successfully!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile");
    }
  };

  const handleProfileImgSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await updateImage(formData, token);
      if (response.success) {
        setProfile((prev) => ({
          ...prev,
          profileimg: response.data.profileimg,
        }));
        setProfileUpdated(true);
        setTimeout(() => setProfileUpdated(false), 500);
        toast.success("Profile image updated!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error updating profile image:", error);
      toast.error("Failed to update profile image");
    }
  };

  const onSubmitAddress = async (data) => {
    try {
      let response;
      if (currentAddress) {
        // Update existing address
        const updatedData = { ...currentAddress, ...data };
        response = await updateUser(updatedData, token);
      } else {
        // Add new address
        response = await addUser(data, token);
      }

      if (response.success) {
        toast.success(
          `Address ${currentAddress ? "updated" : "added"} successfully!`
        );
        setIsEditingAddress(false);
        setCurrentAddress(null);
        // Refresh addresses list
        const addressesResponse = await getUser(token);
        if (addressesResponse.success) {
          setAddresses(addressesResponse.data);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error saving address:", error);
      toast.error("Failed to save address");
    }
  };

  const handleDeleteAddress = async (id) => {
    const formData = new FormData();
    formData.append("addressId", id);

    try {
      const result = await deleteUser(formData, token);
      if (result.success) {
        toast.success("Address deleted successfully");
        const addressesResponse = await getUser(token);
        if (addressesResponse.success) {
          setAddresses(addressesResponse.data);
        }
      }
    } catch (error) {
      console.error("Error deleting address:", error);
      toast.error("Failed to delete address");
    }
  };

  const handleEditAddress = (address) => {
    setCurrentAddress(address);
    setIsEditingAddress(true);
    Object.entries(address).forEach(([key, value]) => {
      setValue(key, value);
    });
  };

  const handleOrderClick = (id) => {
    navigate("/order-details", { state: { id } });
  };

  // const handleDraftClick = (id) => {
  //   // Navigate to draft editing page or continue shopping
  //   toast.info("Continue editing your draft");
  // };

  // const handleDeleteDraft = (id) => {
  //   setDrafts(drafts.filter(draft => draft.id !== id));
  //   toast.success("Draft deleted successfully");
  // };

  const handleContinueDraft = (id) => {
    // Logic to continue with draft
    toast.info("Continue shopping with your saved items");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  };

  if (isLoading) {
    return (
      <div className="profile-container">
        <div className="profile-content">
          <SkeletonLoader type="profile" />
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-content">
        {/* Sidebar Navigation */}
        <div className="profile-sidebar">
          <div className="profile-user">
            <div className="profile-picture">
              {profile.profileimg ? (
                <img
                  src={`${configUrl}/${profile.profileimg}`}
                  alt="Profile"
                  className="profile-image"
                />
              ) : (
                <div className="profile-image-placeholder">
                  {profile.name.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
            <h3 className="profile-username">{profile.name}</h3>
            <p className="profile-email">{profile.email}</p>
          </div>

          <nav className="profile-nav">
            <ul>
              <li>
                <button
                  className={activeTab === "profile" ? "active" : ""}
                  onClick={() => setActiveTab("profile")}
                >
                  <i className="fas fa-user"></i> Profile
                </button>
              </li>
              <li>
                <button
                  className={activeTab === "addresses" ? "active" : ""}
                  onClick={() => setActiveTab("addresses")}
                >
                  <i className="fas fa-map-marker-alt"></i> Addresses
                </button>
              </li>
              <li>
                <button
                  className={activeTab === "orders" ? "active" : ""}
                  onClick={() => setActiveTab("orders")}
                >
                  <i className="fas fa-shopping-bag"></i> Orders
                </button>
              </li>
              <li>
                <button
                  className={activeTab === "drafts" ? "active" : ""}
                  onClick={() => setActiveTab("drafts")}
                >
                  <i className="fas fa-file-alt"></i> Drafts
                </button>
              </li>
            </ul>
          </nav>
        </div>

        {/* Main Content */}
        <div className="profile-main">
          {/* Profile Tab */}
          {activeTab === "profile" && (
            <div className="profile-section">
              <h2 className="section-title">Profile Information</h2>

              {isEditing ? (
                <form
                  onSubmit={handleSubmit(onSubmitProfile)}
                  className="profile-form"
                >
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      {...register("name", { required: "Name is required" })}
                      defaultValue={profile.name}
                    />
                    {errors.name && (
                      <span className="error">{errors.name.message}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      {...register("email", { required: "Email is required" })}
                      defaultValue={profile.email}
                    />
                    {errors.email && (
                      <span className="error">{errors.email.message}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="gender">Gender</label>
                    <select
                      id="gender"
                      {...register("gender", {
                        required: "Gender is required",
                      })}
                      defaultValue={profile.gender}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                    {errors.gender && (
                      <span className="error">{errors.gender.message}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="dob">Date of Birth</label>
                    <input
                      type="date"
                      id="dob"
                      {...register("dob", { required: "DOB is required" })}
                      defaultValue={profile.dob}
                    />
                    {errors.dob && (
                      <span className="error">{errors.dob.message}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Profile Picture</label>
                    <div className="file-upload">
                      <input
                        type="file"
                        onChange={handleFileChange}
                        id="profile-img"
                      />
                      <label htmlFor="profile-img" className="upload-btn">
                        Choose File
                      </label>
                      {selectedFile && <span>{selectedFile.name}</span>}
                    </div>
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn-primary">
                      Save Changes
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsEditing(false)}
                      className="btn-secondary"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <div className="profile-info">
                  <div className="info-row">
                    <span className="info-label">Name:</span>
                    <span className="info-value">{profile.name}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Email:</span>
                    <span className="info-value">{profile.email}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Gender:</span>
                    <span className="info-value">
                      {profile.gender || "Not specified"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Date of Birth:</span>
                    <span className="info-value">
                      {profile.dob || "Not specified"}
                    </span>
                  </div>

                  <button
                    onClick={() => setIsEditing(true)}
                    className="btn-primary edit-btn"
                  >
                    Edit Profile
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Addresses Tab */}
          {activeTab === "addresses" && (
            <div className="profile-section">
              <h2 className="section-title">SELECT DELIVERY ADDRESS</h2>

              {isEditingAddress ? (
                <form
                  onSubmit={handleSubmit(onSubmitAddress)}
                  className="address-form"
                >
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      className="form-input"
                      placeholder="Full name"
                      {...register("name", {
                        required: "Full name is required",
                      })}
                    />
                    {errors.name && (
                      <p className="error-message">{errors.name.message}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      id="mobile_no"
                      className="form-input"
                      placeholder="Phone Number"
                      {...register("mobile_no", {
                        required: "Phone number is required",
                      })}
                    />
                    {errors.mobile_no && (
                      <p className="error-message">
                        {errors.mobile_no.message}
                      </p>
                    )}
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      id="address"
                      className="form-input"
                      placeholder="Address"
                      {...register("address", {
                        required: "Address is required",
                      })}
                    />
                    {errors.address && (
                      <p className="error-message">{errors.address.message}</p>
                    )}
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="text"
                        id="city"
                        className="form-input"
                        placeholder="City"
                        {...register("city", { required: "City is required" })}
                      />
                      {errors.city && (
                        <p className="error-message">{errors.city.message}</p>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        id="state"
                        className="form-input"
                        placeholder="State"
                        {...register("state", {
                          required: "State is required",
                        })}
                      />
                      {errors.state && (
                        <p className="error-message">{errors.state.message}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <CustomDropdown
                        options={countries}
                        onSelect={(value) => setValue("country", value)}
                        register={register}
                        name="country"
                        errors={errors}
                        placeholder="Country"
                        className="form-input"
                      />
                      {errors.country && (
                        <p className="error-message">
                          {errors.country.message}
                        </p>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        id="pincode"
                        className="form-input"
                        placeholder="Zip Code (Postal Code)"
                        {...register("pincode", {
                          required: "Zip code is required",
                        })}
                      />
                      {errors.pincode && (
                        <p className="error-message">
                          {errors.pincode.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="save-button">
                      SAVE ADDRESS
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setIsEditingAddress(false);
                        setCurrentAddress(null);
                      }}
                      className="cancel-button"
                    >
                      CANCEL
                    </button>
                  </div>
                </form>
              ) : (
                <>
                  {isAddressLoading ? (
                    <SkeletonLoader type="address" />
                  ) : (
                    <div className="addresses-container">
                      <button
                        onClick={() => setIsEditingAddress(true)}
                        className="add-address-button"
                      >
                        + Add New Address
                      </button>

                      {addresses.length > 0 ? (
                        <div className="address-list">
                          {addresses.map((address) => (
                            <div key={address.id} className="address-card">
                              <div className="address-details">
                                <h4 className="address-name">{address.name}</h4>
                                <p className="address-info">
                                  {address.address}
                                </p>
                                <p className="address-info">
                                  {address.city}, {address.state},{" "}
                                  {address.country}
                                </p>
                                <p className="address-info">
                                  Zip: {address.pincode}
                                </p>
                                <p className="address-info">
                                  Phone: {address.mobile_no}
                                </p>
                              </div>
                              <div className="address-actions">
                                <button
                                  onClick={() => handleEditAddress(address)}
                                  className="edit-button"
                                >
                                  Edit
                                </button>
                                <button
                                  className="delete-button"
                                  onClick={() =>
                                    handleDeleteAddress(address.id)
                                  }
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="empty-state">
                          <i className="fas fa-map-marker-alt"></i>
                          <p>You haven't saved any addresses yet</p>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {/* Orders Tab */}
          {activeTab === "orders" && (
            <div className="profile-section">
              <h2 className="section-title">My Orders</h2>

              {isOrdersLoading ? (
                <SkeletonLoader type="orders" />
              ) : (
                <div className="orders-container">
                  {orders.length > 0 ? (
                    <div className="order-list">
                      {orders.map((order) => (
                        <div
                          key={order.id}
                          className="order-card"
                          onClick={() => handleOrderClick(order.id)}
                        >
                          <div className="order-header">
                            <span className="order-id">Order #{order.id}</span>
                            <span className="order-date">
                              {formatDate(order.created_at)}
                            </span>
                          </div>
                          <div className="order-details">
                            <div className="order-status">
                              <span>Status:</span>
                              <span
                                className={`status-${order.order_status.toLowerCase()}`}
                              >
                                {order.order_status}
                              </span>
                            </div>
                            <div className="order-total">
                              <span>Total:</span>
                              <span>${order.total_amount}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="empty-state">
                      <i className="fas fa-shopping-bag"></i>
                      <p>You haven't placed any orders yet</p>
                      <button
                        className="btn-primary"
                        onClick={() => navigate("/")}
                      >
                        Start Shopping
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Drafts Tab */}

          <div className="drafts-container">
            {drafts.length > 0 ? (
              <div className="drafts-grid">
                {drafts.map((draft) => {
                  console.log("Rendering draft:", draft);
                  return (
                    <div key={draft.id} className="draft-card-grid">
                      {/* Debug info - remove in production */}
                      {process.env.NODE_ENV === "development" && (
                        <div
                          className="debug-info"
                          style={{
                            fontSize: "10px",
                            color: "#666",
                            background: "#f0f0f0",
                            padding: "5px",
                            marginBottom: "10px",
                            borderRadius: "4px",
                            display: "none",
                          }}
                        >
                          ID: {draft.id} | Cart: {draft.cartId} | GLB:{" "}
                          {draft.glbId}
                        </div>
                      )}

                      {/* Header with user info and status */}
                      <div className="draft-grid-header">
                        <div className="draft-user-info">
                          <FaTh className="grid-icon-small" />
                          <span className="draft-username">
                            {draft.userName}
                          </span>
                        </div>
                        <span className="status-badge-grid">NOT ORDERED</span>
                      </div>

                      {/* Product Title */}
                      <h3 className="draft-product-title">JERSEY</h3>

                      {/* Creation Date */}
                      <p className="draft-creation-date">
                        Created {formatDate(draft.date)}
                      </p>

                      {/* Product Image */}
                      <div className="draft-image-grid">
                        <img
                          src={draft.productImage}
                          alt={draft.productTitle}
                          className="jersey-image-grid"
                          onError={(e) => {
                            console.error(
                              "Image failed to load:",
                              draft.productImage
                            );
                            e.target.src = "../glbImage.png";
                          }}
                        />
                      </div>

                      {/* Product Details Grid */}
                      <div className="draft-details-grid">
                        <div className="detail-item">
                          <span className="detail-label">Size:</span>
                          <span className="detail-value">{draft.size}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Qty:</span>
                          <span className="detail-value">{draft.items}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Price:</span>
                          <span className="detail-value">{draft.total}</span>
                        </div>
                      </div>

                      <div className="draft-more-options-grid">
                        <button
                          className="more-options-btn-grid"
                          onClick={() => handleDraftClick(draft)}
                          title="Edit Design"
                        >
                          <FaPen />
                        </button>
                        {/* <button
                          className="more-options-btn-grid"
                          title="Duplicate Design"
                        >
                          <FaCopy />
                        </button>
                        <button
                          className="more-options-btn-grid"
                          title="View 3D Preview"
                        >
                          <FaEye />
                        </button> */}
                        <button
                          className="more-options-btn-grid delete-btn-grid"
                          onClick={() =>
                            handleDeleteDraft(draft.id, draft.cartId)
                          }
                          title="Delete Draft"
                        >
                          <FaTrashAlt />
                        </button>
                      </div>

                      {/* Action Buttons */}
                      <div
                        className="draft-actions-grid"
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        {/* <button className="add-to-cart-grid">
                          <FaCartPlus className="cart-icon-grid" />
                          Add to cart
                        </button> */}
                        {/* <button className="share-design-grid">
                          <FaShareAlt className="share-icon-grid" />
                          Share design
                        </button> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="empty-drafts">
                <p>No drafts found</p>
              </div>
            )}
          </div>

          {/* {activeTab === "drafts" && (
  <div className="profile-section">
    <h2 className="section-title">Drafts</h2>

    {isDraftsLoading ? (
      <div className="skeleton-orders">
        {[...Array(3)].map((_, idx) => (
          <div key={idx} className="skeleton-order-card">
            <div className="skeleton-row"></div>
            <div className="skeleton-row"></div>
            <div className="skeleton-row"></div>
            <div className="skeleton-row"></div>
          </div>
        ))}
      </div>
    ) : (
     <div className="draft-ticket-card">
  <div className="ticket-header">
    <i className="fas fa-th"></i>
    <span className="user-name">Samriddhi Sinha</span>
    <i className="fas fa-pencil-alt"></i>
  </div>

  <div className="ticket-content">
    <div className="ticket-image-section">
      <button className="favorite-btn"><i className="far fa-star"></i></button>
      <img src="../glbImage.png" alt="Jersey" className="jersey-preview" />
    </div>

    <div className="ticket-details">
      <span className="status-badge-red">NOT ORDERED</span>
      <h4 className="product-title">Rio men's football jersey <i className="fas fa-info-circle"></i></h4>
      <p className="creation-date">Created 28.12.2025</p>
    </div>

    <div className="utility-actions">
      <button className="util-btn"><i className="fas fa-pencil-alt"></i></button>
      <button className="util-btn"><i className="far fa-copy"></i></button>
      <button className="util-btn"><i className="fas fa-th-large"></i></button>
      <button className="util-btn"><i className="fas fa-ellipsis-v"></i></button>
    </div>

    <div className="ticket-main-actions">
      <button className="add-to-cart-full">Add to cart</button>
      <button className="share-design-link">
        <i className="fas fa-share-alt"></i> Share design
      </button>
    </div>
  </div>
</div>
    )}
  </div>
)} */}
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Profile container styles */
        .profile-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .profile-content {
          display: flex;
          flex: 1;
          background-color: #f8f9fa;
        }

        /* Sidebar styles */
        .profile-sidebar {
          width: 280px;
          background: white;
          padding: 30px 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .profile-user {
          text-align: center;
          margin-bottom: 30px;
        }

        .profile-picture {
          margin: 0 auto 15px;
        }

        .profile-image {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          object-fit: cover;
          border: 4px solid #f1f1f1;
        }

        .profile-image-placeholder {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #e9ecef;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-size: 36px;
          color: #495057;
          border: 4px solid #f1f1f1;
        }

        .profile-username {
          font-size: 18px;
          margin-bottom: 5px;
          color: #333;
        }

        .profile-email {
          font-size: 14px;
          color: #6c757d;
        }

        .profile-nav ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .profile-nav li button {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 12px 15px;
          background: none;
          border: none;
          text-align: left;
          color: #495057;
          text-decoration: none;
          border-radius: 5px;
          margin-bottom: 5px;
          transition: all 0.3s;
          cursor: pointer;
        }

        .profile-nav li button i {
          margin-right: 10px;
          width: 20px;
          text-align: center;
        }

        .profile-nav li button:hover {
          background: #f1f1f1;
          color: #000;
        }

        .profile-nav li button.active {
          background: #f1f1f1;
          color: #000;
          font-weight: 500;
        }

        /* Main content styles */
        .profile-main {
          flex: 1;
          padding: 30px;
          background: white;
          margin: 20px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .section-title {
          font-size: 24px;
          margin-bottom: 25px;
          color: #333;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
        }

        /* Address section specific styles */
        .addresses-container {
          margin-top: 20px;
        }

        .add-address-button {
          background-color: #000;
          color: white;
          border: none;
          border-radius: 30px;
          padding: 12px 30px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.3s;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .add-address-button:hover {
          background-color: #333;
        }

        .address-list {
          display: grid;
          gap: 20px;
        }

        .address-card {
          padding: 20px;
          border: 1px solid #eee;
          border-radius: 12px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          transition: all 0.3s;
        }

        .address-card:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .address-details {
          flex: 1;
        }

        .address-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 10px;
          color: #333;
        }

        .address-info {
          font-size: 14px;
          color: #555;
          margin-bottom: 5px;
        }

        .address-actions {
          display: flex;
          gap: 10px;
        }

        .edit-button,
        .delete-button {
          padding: 8px 15px;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          transition: background-color 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .edit-button {
          background-color: #007bff;
        }

        .edit-button:hover {
          background-color: #0069d9;
        }

        .delete-button {
          background-color: #dc3545;
        }

        .delete-button:hover {
          background-color: #c82333;
        }

        /* Drafts section specific styles */
        .drafts-container {
          margin-top: 20px;
        }

        .drafts-list {
          display: grid;
          gap: 20px;
        }

        .draft-card {
          padding: 20px;
          border: 1px solid #eee;
          border-radius: 12px;
          transition: all 0.3s;
          background: #fafafa;
        }

        .draft-card:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          background: #fff;
        }

        .draft-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 15px;
        }

        .draft-title-section {
          flex: 1;
        }

        .draft-id {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          display: block;
          margin-bottom: 5px;
        }

        .draft-date {
          font-size: 14px;
          color: #6c757d;
        }

        .draft-badge {
          background: #ffc107;
          color: #212529;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .draft-details {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 15px;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 1px solid #eee;
        }

        .draft-info {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .draft-info .info-label {
          font-size: 14px;
          color: #6c757d;
          font-weight: 500;
        }

        .draft-info .info-value {
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }

        .draft-status {
          color: #ffc107;
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
        }

        .draft-actions {
          display: flex;
          gap: 10px;
        }

        .draft-continue-btn {
          padding: 10px 20px;
          background: #000;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: background 0.3s;
          flex: 1;
        }

        .draft-continue-btn:hover {
          background: #333;
        }

        .draft-delete-btn {
          padding: 10px 20px;
          background: #f8f9fa;
          color: #dc3545;
          border: 1px solid #dc3545;
          border-radius: 5px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s;
          flex: 1;
        }

        .draft-delete-btn:hover {
          background: #dc3545;
          color: white;
        }

        /* Empty state styles */
        .empty-state {
          text-align: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 10px;
        }

        .empty-state i {
          font-size: 50px;
          color: #6c757d;
          margin-bottom: 20px;
        }

        .empty-state p {
          font-size: 18px;
          color: #6c757d;
          margin-bottom: 20px;
        }

        .empty-subtext {
          font-size: 14px !important;
          color: #868e96 !important;
          margin-bottom: 30px !important;
          max-width: 400px;
          margin: 0 auto 30px !important;
        }

        /* Skeleton loader styles */
        .skeleton-container {
          padding: 40px;
          max-width: 600px;
          margin: 0 auto;
        }

        .skeleton {
          background-color: #e2e2e2;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-circle {
          width: 140px;
          height: 140px;
          margin: 0 auto 25px;
          border-radius: 50%;
        }

        .skeleton-text {
          height: 20px;
          margin-bottom: 20px;
          width: 100%;
        }

        .skeleton-orders {
          display: grid;
          gap: 20px;
        }

        .skeleton-order-card {
          padding: 20px;
          border: 1px solid #eee;
          border-radius: 12px;
          background: #fff;
        }

        .skeleton-row {
          height: 16px;
          background-color: #e2e2e2;
          border-radius: 4px;
          margin-bottom: 10px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .profile-content {
            flex-direction: column;
          }

          .profile-sidebar {
            width: 100%;
            padding: 20px;
          }

          .profile-nav ul {
            display: flex;
            overflow-x: auto;
            padding-bottom: 10px;
          }

          .profile-nav li {
            flex: 0 0 auto;
          }

          .profile-nav li button {
            margin-bottom: 0;
            margin-right: 10px;
          }

          .profile-main {
            margin: 0;
            border-radius: 0;
            padding: 20px;
          }

          .address-card,
          .draft-card {
            flex-direction: column;
            gap: 15px;
          }

          .address-actions,
          .draft-actions {
            justify-content: flex-end;
            width: 100%;
          }

          .draft-details {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <style jsx>{`
        .profile-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .profile-content {
          display: flex;
          flex: 1;
          background-color: #f8f9fa;
        }

        .profile-sidebar {
          width: 280px;
          background: white;
          padding: 30px 20px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .profile-user {
          text-align: center;
          margin-bottom: 30px;
        }

        .profile-picture {
          margin: 0 auto 15px;
        }

        .profile-image {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          object-fit: cover;
          border: 4px solid #f1f1f1;
        }

        .profile-image-placeholder {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #e9ecef;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-size: 36px;
          color: #495057;
          border: 4px solid #f1f1f1;
        }

        .profile-username {
          font-size: 18px;
          margin-bottom: 5px;
          color: #333;
        }

        .profile-email {
          font-size: 14px;
          color: #6c757d;
        }

        .profile-nav ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .profile-nav li button {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 12px 15px;
          background: none;
          border: none;
          text-align: left;
          color: #495057;
          text-decoration: none;
          border-radius: 5px;
          margin-bottom: 5px;
          transition: all 0.3s;
          cursor: pointer;
        }

        .profile-nav li button i {
          margin-right: 10px;
          width: 20px;
          text-align: center;
        }

        .profile-nav li button:hover {
          background: #f1f1f1;
          color: #000;
        }

        .profile-nav li button.active {
          background: #f1f1f1;
          color: #000;
          font-weight: 500;
        }

        .profile-main {
          flex: 1;
          padding: 30px;
          background: white;
          margin: 20px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .section-title {
          font-size: 24px;
          margin-bottom: 25px;
          color: #333;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
        }

        .profile-form,
        .address-form {
          max-width: 600px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #555;
        }

        .form-group input,
        .form-group select {
          width: 100%;
          padding: 10px 15px;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 16px;
          transition: border 0.3s;
        }

        .form-group input:focus,
        .form-group select:focus {
          border-color: #007bff;
          outline: none;
        }

        .error {
          color: #dc3545;
          font-size: 14px;
          margin-top: 5px;
          display: block;
        }

        .file-upload {
          display: flex;
          align-items: center;
        }

        .file-upload input[type="file"] {
          display: none;
        }

        .upload-btn {
          padding: 10px 15px;
          background: #f8f9fa;
          border: 1px solid #ddd;
          border-radius: 5px;
          cursor: pointer;
          margin-right: 10px;
          transition: all 0.3s;
        }

        .upload-btn:hover {
          background: #e9ecef;
        }

        .form-actions {
          display: flex;
          gap: 15px;
          margin-top: 25px;
        }

        .btn-primary {
          padding: 10px 20px;
          background: #000;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px;
          transition: background 0.3s;
        }

        .btn-primary:hover {
          background: #333;
        }

        .btn-secondary {
          padding: 10px 20px;
          background: #6c757d;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px;
          transition: background 0.3s;
        }

        .btn-secondary:hover {
          background: #5a6268;
        }

        .profile-info {
          max-width: 600px;
        }

        .info-row {
          display: flex;
          margin-bottom: 15px;
          padding-bottom: 15px;
          border-bottom: 1px solid #f1f1f1;
        }

        .info-label {
          font-weight: 500;
          color: #555;
          width: 150px;
        }

        .info-value {
          flex: 1;
          color: #333;
        }

        .edit-btn {
          margin-top: 20px;
        }

        .addresses-container,
        .orders-container {
          margin-top: 20px;
        }

        .address-list {
          display: grid;
          gap: 20px;
        }

        .address-card {
          padding: 20px;
          border: 1px solid #eee;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .address-details {
          flex: 1;
        }

        .address-actions {
          display: flex;
          gap: 10px;
        }

        .btn-edit {
          padding: 5px 10px;
          background: #007bff;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .btn-delete {
          padding: 5px 10px;
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .add-address-btn {
          margin-top: 20px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .order-list {
          display: grid;
          gap: 15px;
        }

        .order-card {
          padding: 15px;
          border: 1px solid #eee;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
        }

        .order-card:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .order-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        }

        .order-id {
          font-weight: bold;
        }

        .order-date {
          color: #6c757d;
        }

        .order-details {
          display: flex;
          justify-content: space-between;
        }

        .order-status {
          display: flex;
          gap: 5px;
        }

        .status-pending {
          color: #ffc107;
        }

        .status-completed {
          color: #28a745;
        }

        .status-cancelled {
          color: #dc3545;
        }

        .order-total {
          display: flex;
          gap: 5px;
        }

        .empty-state {
          text-align: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 10px;
        }

        .empty-state i {
          font-size: 50px;
          color: #6c757d;
          margin-bottom: 20px;
        }

        .empty-state p {
          font-size: 18px;
          color: #6c757d;
          margin-bottom: 20px;
        }

        /* Skeleton styles */
        .skeleton-container {
          padding: 40px;
          max-width: 600px;
          margin: 0 auto;
        }

        .skeleton {
          background-color: #e2e2e2;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        .skeleton-circle {
          width: 140px;
          height: 140px;
          margin: 0 auto 25px;
          border-radius: 50%;
        }

        .skeleton-text {
          height: 20px;
          margin-bottom: 20px;
          width: 100%;
        }

        .skeleton-orders {
          display: grid;
          gap: 15px;
        }

        .skeleton-order-card {
          padding: 15px;
          border: 1px solid #eee;
          border-radius: 8px;
        }

        .skeleton-row {
          height: 16px;
          background-color: #e2e2e2;
          border-radius: 4px;
          margin-bottom: 10px;
          animation: pulse 1.5s infinite ease-in-out;
        }

        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }

        @media (max-width: 768px) {
          .profile-content {
            flex-direction: column;
            width: 100%;
          }

          .profile-sidebar {
            width: 100%;
            padding: 20px;
          }

          .profile-nav ul {
            display: flex;
            overflow-x: auto;
            padding-bottom: 10px;
          }

          .profile-nav li {
            flex: 0 0 auto;
          }

          .profile-nav li a {
            margin-bottom: 0;
            margin-right: 10px;
          }

          .profile-main {
            margin: 0;
            border-radius: 0;
            padding: 20px;
          }

          .info-row {
            flex-direction: column;
          }

          .info-label {
            width: 100%;
            margin-bottom: 5px;
          }

          .address-card {
            flex-direction: column;
            gap: 15px;
          }

          .address-actions {
            justify-content: flex-end;
          }
        }
        @media (max-width: 568px) {
          .profile-nav li button {
            padding: 8px 4px;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

export default Profile;
